"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../styles");
const styles = styles_1.createStyles(({ typography, palette, spacing }) => {
    return Object.assign(Object.assign(Object.assign({ root: {
            margin: 0,
            color: palette.textPrimary,
        }, block: {
            display: 'block',
        }, inline: {
            display: 'inline',
        }, wrap: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        }, gutterBottom: {
            marginBottom: spacing(1),
        }, withPlaceholder: {
            '&:empty::before': {
                content: '"\\2014"',
                color: palette.textSecondary,
            },
        } }, styles_1.TYPOGRAPHY_VARIANTS.reduce((acc, variant) => (Object.assign(Object.assign({}, acc), { [`variant-${variant}`]: typography[variant] })), {})), styles_1.TYPOGRAPHY_WEIGHTS.reduce((acc, weight) => (Object.assign(Object.assign({}, acc), { [`weight-${weight}`]: {
            fontWeight: typography.weights[weight],
        } })), {})), styles_1.TYPOGRAPHY_FONTS.reduce((acc, font) => (Object.assign(Object.assign({}, acc), { [`font-${font}`]: {
            fontFamily: typography.fonts[font],
        } })), {}));
});
exports.decorate = styles_1.withStyles(styles, { injectTheme: true });
